/*******************************************************************************
LOAD ALL AJAX URLS
Look for any "ajax-load" data attributes and use them to load data into the targeted elements.
*******************************************************************************/
/* eslint-disable no-console */

import updateCheckboxFilter from '../filter-checkboxes/update-filter';

export default async function getDataAJAX() {
    const loadingErrorMessage = 'We were unable to load this data. Please try again.';

    // Find all the AJAX urls to load
    $('[data-ajax-load]').each(async (index, element) => {
        const ajaxURL = $(element).data('ajax-load');
        const targets = $(element).data('ajax-targets').split(',');
        const emptyDataMessage = $(element).data('ajax-empty') || '';

        // Tables need to be handled differently than everything else.
        // So if any of the target elements are a table, then we need to exit without running an AJAX request.
        let tableDetected = false;
        let targetMissing = false;
        targets.forEach((target) => {
            if ($(target).length === 0) { targetMissing = true; }

            if ($(target).is('table')) {
                const targetName = target.replace('#', '');
                tableDetected = true;

                // Set the AJAX url, AJAX data source and (optionally) the 'noresults' data attribute on the table element
                // Both these attributes are used when loading the table with DataTables
                $(target).data('ajaxsource', ajaxURL);
                $(target).data('datasource', targetName);
                if (emptyDataMessage) { $(target).data('noresults', emptyDataMessage); }
            }
        });
        if (targetMissing || tableDetected) { return; }

        // Run the AJAX request and load the data returned into the target elements
        try {
            const response = await $.ajax({
                type   : 'GET',
                url    : ajaxURL,
                timeout: 120000, // 2 minute timeout to accommodate slow MyRotoWire query (reduce later?)
            });

            // Check for errors with the data
            if (response.error || !response.success) { throw new Error(response.error); }

            // Load the data into the targets
            targets.forEach((target) => {
                const $target = $(target);
                const targetName = target.replace('#', '');
                const targetHTML = (targetName in response) ? response[targetName] : 'data not returned';

                if ($target.get(0).tagName === "META") { return; }

                // If the target element does not exists, let the developer know in the console
                if ($target.length === 0) {
                    console.log('The element you are targeting does not exist on the page.');
                }

                // If the data for the targeted element does not exist, let the developer and user know.
                if (targetHTML === 'data not returned') {
                    $target.replaceWith(loadingErrorMessage);
                    console.log('The data for your targeted element is not being returned.');
                }

                // If the AJAX call was successful, but the data came back empty, display a message to the user.
                if (!targetHTML) {
                    $target.replaceWith(emptyDataMessage || 'No data was found.');
                }

                // Load the data into the target
                $target.replaceWith(targetHTML);
            });

            // Initialize the checkbox filters that were waiting for the AJAX to finish
            $('.filter-checkbox.waiting-for-ajax').each((i, checkbox) => {
                const checkboxName = $(checkbox).data('name');
                updateCheckboxFilter(checkboxName);
            });
        }
        catch (error) {
            targets.forEach((target) => { $(target).replaceWith(loadingErrorMessage); });
        }
    });
}
